import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  SYNC_NYLAS_LINK: `${cleanedFilename(__filename)}-sync-nylas-link`,
  EXPANDABLE_EMAIL_SYNC_FORM: `${cleanedFilename(
    __filename,
  )}-expandable-email-sync-form`,
};
